import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { BlueButton, GrayButton } from "../../styles/buttons";
import { OnlyLogo } from "../../styles/logos";
import { BoxTitle, BoxSubTitle, LeftBoxTitle, LeftBoxSubTitle } from "../../styles/texts";
import { InvisibleExternalBox, GrayBorderBox, InternalLeftBox, InternalCenterBox } from "../../styles/boxes";
import { LoginForm } from "../../styles/forms";

import validateEmail from "./validateEmail";
import validatePhone from "./validatePhone";

const SendLink: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const method = queryParams.get("method");
  const chosenMethod = method === "email" ? "Email" : "WhatsApp";
  const otherMethod = chosenMethod === "Email" ? "WhatsApp" : "Email";

  const [inputValue, setInputValue] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const changeMethod = (newMethod: "Email" | "WhatsApp") => {
    const goTo = newMethod === "Email" ? "email" : "whatsapp";
    navigate(`/sendlink?method=${goTo}`);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    let validationResult = -1;
    if (method === "email") {
      validationResult = await validateEmail(inputValue);
    } else if (method === "whatsapp") {
      validationResult = await validatePhone(inputValue);
    }

    if (validationResult === 0) {
      navigate("/receivelink", { state: { contact: inputValue } });
    }
    else if (validationResult === 1) {
      setErrorMessage(method === "email" ? "Correo inválido" : "Teléfono inválido");
    }
    else {
      setErrorMessage("Ocurrió un error inesperado. Por favor, intenta nuevamente.");
    }
  };

  return (
    <InvisibleExternalBox w="434px" h="459px">
      <GrayBorderBox w="459px" h="388px">

        <OnlyLogo h="24px" />
        <BoxTitle>Iniciar Sesión</BoxTitle>
        <BoxSubTitle>Elige por dónde quieres recibir tu link de acceso</BoxSubTitle>

        <form onSubmit={handleSubmit} className="flex flex-col items-center justify-center w-[395px]">
          <InternalCenterBox w="395px" h="115px" g="8px">
            <LoginForm
              method={method || "email"}
              onChange={(e) => setInputValue(e.target.value)}
              h="40px"
            />

            <BlueButton
              label="Enviar Link"
              w="395px"
              h="44px"
              type="submit"
            />
          </InternalCenterBox>
        </form>

        {errorMessage && (
          <div className="text-red-500 mt-2">
            {errorMessage}
          </div>
        )}

        <InternalLeftBox w="395px" h="40px">
          <GrayButton
            label={`Cambiar a link por ${otherMethod}`}
            onClick={() => changeMethod(otherMethod as "Email" | "WhatsApp")}
            h="32px"
          />
        </InternalLeftBox>
      </GrayBorderBox>

      <GrayBorderBox w="459px" h="157px">

        <InternalLeftBox w="395px" h="150px" g="8px">
          <LeftBoxTitle>¿No tienes cuenta?</LeftBoxTitle>
          <LeftBoxSubTitle>Primero debes iniciar un proceso de cotización.</LeftBoxSubTitle>
          <GrayButton
            label="Cotizar"
            onClick={() => window.open("https://ruuf.cl", "_blank")}
            w="89px"
            h="32px"
            icon="righthead"
          />
        </InternalLeftBox>

      </GrayBorderBox>

    </InvisibleExternalBox>
  );
};

export default SendLink;
